export function mapObj<T, V>(obj: { [key: string]: T }, mapper: (e: T) => V, defaultObj: { [key: string]: V } = null) {
  if (!obj) return defaultObj;
  const result: { [key: string]: V } = {};
  Object.entries(obj).forEach(entry => {
    const [key, value] = entry;
    result[key] = mapper(value);
  });
  return result;
}
